if (!customElements.get('hot-spot')) {
  customElements.define('hot-spot', class Hotspot extends HTMLElement {
    constructor() {
      super();
      
      this.init();
      this.addEventListener('click', this.handleClick.bind(this));
    }

    init() {
      const computedStyle = getComputedStyle(this);
      const horizontalPosition = parseFloat(computedStyle.getPropertyValue('--hotspot-horizontal-position'));

      if (horizontalPosition > 50) {
        this.style.setProperty('--calculated-max-width', `calc(100% - (100% - ${horizontalPosition}%))`);
      } else {
        this.style.setProperty('--calculated-max-width', `calc(100% - ${horizontalPosition}%)`);
      }
    }

    handleClick(event) {
      if (!this.hasAttribute('href')) {
        this.classList.toggle('active');
      }
    }
  });
}